<div class="block-practices d-flex align-items-center">
    <div class="d-flex align-items-center justify-content-between gap-12 w-100" (click)="openWindow()" style="cursor: pointer;">
        <div class="d-flex align-items-center justify-content-start gap-12">
            <div class="d-flex align-items-center justify-content-center icon">
                <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px" fill="#ffffff"><path d="M336-240h288v-72H336v72Zm0-144h288v-72H336v72ZM263.72-96Q234-96 213-117.15T192-168v-624q0-29.7 21.15-50.85Q234.3-864 264-864h312l192 192v504q0 29.7-21.16 50.85Q725.68-96 695.96-96H263.72ZM528-624v-168H264v624h432v-456H528ZM264-792v189-189 624-624Z"/></svg>
            </div>
            <div class="d-flex flex-column gap-4p">
                <span class="name-title">{{ 'practices.txtTitle' | translate }}</span>
                <span class="info-files">{{countFiles()}} {{ 'practices.txtManyFile' | translate }}</span>
            </div>
        </div>
        <div class="d-flex align-items-center justify-content-center open-pdf-info">
            <svg  xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px" fill="#000000CC"><path d="M522-480 333-669l51-51 240 240-240 240-51-51 189-189Z"/></svg>
        </div>
    </div>
</div>
